
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"161","height":"160","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"80.5","cy":"80","r":"80","fill":"#C8AD7D","fill-opacity":".1"}}),_c('circle',{attrs:{"cx":"80.5","cy":"80","r":"60","fill":"#C8AD7D","fill-opacity":".1"}}),_c('circle',{attrs:{"cx":"80.5","cy":"80","r":"40","fill":"#C8AD7D"}}),_c('path',{attrs:{"d":"M66 80.877l9.995 9.65L98.292 69","stroke":"url(#paint0_linear)","stroke-width":"5","stroke-linecap":"round"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear","x1":"61.479","y1":"79.333","x2":"102.167","y2":"79.333","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#fff"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#fff","stop-opacity":".75"}})])])])
          )
        }
      }
    